import { UAParser as UAParserOrigin } from 'ua-parser-js';
import { SHA256 } from 'crypto-js';
import { isMobile } from 'react-device-detect';
import { v4 as uuidv4 } from 'uuid';
export * from './email';
export * from './time';
export const __DEBUGGER__ = (...args) => {
    const isDebugEnable = !!localStorage.getItem('__DEBUGGER__');
    if (isDebugEnable) {
        console.debug(args);
    }
};
export const hashPassword = (pwd) => SHA256(pwd).toString();
export function loadScript(src, id, params = {}) {
    const firstScripTag = document.head.getElementsByTagName('script')[0];
    const scriptTagToInsert = document.createElement('script');
    scriptTagToInsert.id = id;
    scriptTagToInsert.src = src;
    scriptTagToInsert.async = true;
    scriptTagToInsert.defer = true;
    typeof params.onLoad === 'function' && (scriptTagToInsert.onload = params.onLoad);
    typeof params.onError === 'function' && (scriptTagToInsert.onerror = params.onError);
    if (firstScripTag?.parentNode) {
        firstScripTag.parentNode.insertBefore(scriptTagToInsert, firstScripTag);
    }
    else {
        document.head.appendChild(scriptTagToInsert);
    }
}
export function removeScript(elementId) {
    const element = document.getElementById(elementId);
    if (element?.parentNode) {
        element.parentNode.removeChild(element);
    }
}
export const serializeError = (error) => {
    const message = error && error.message;
    if (message) {
        return { message };
    }
    return { message: 'Something went wrong' };
};
export const isMobileDevice = () => isMobile;
export const getDomainAndURI = () => {
    if (typeof window === 'undefined')
        return { domain: '', uri: '' };
    const { hostname, origin, pathname } = window.location;
    return {
        domain: hostname,
        // uri: origin + pathname,
        // Hotfix: Depend on Ronin extension
        uri: origin + pathname,
    };
};
export const popupCenter = ({ url, title, w = 600, h = 600 }) => {
    const left = (screen.width - w) / 2;
    const top = (screen.height - h) / 2;
    return window.open(url, title, 'resizable=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
};
export const randomUUID = () => uuidv4();
export const UAParser = new UAParserOrigin();
export const base64Encode = (str) => {
    const encoded = Buffer.from(str).toString('base64');
    return encoded;
};
export const base64Decode = (str) => {
    const decoded = Buffer.from(str, 'base64').toString('ascii');
    return decoded;
};
export const isTheSameOrigin = (url) => url && new URL(url).origin === window.location.origin;
export const isCustomProtocol = (link) => {
    try {
        const { protocol } = new URL(link);
        return protocol !== 'http:' && protocol !== 'https:';
    }
    catch (e) {
        return false;
    }
};
//# sourceMappingURL=index.js.map